export const contactsData = {
    email: 'mavinsandeep@gmail.com',
    phone: '+91 8248944557',
    address: 'Tiruchirappalli, Tamil Nadu, India',
    github: 'https://github.com/userdevil/',
    facebook: 'https://www.facebook.com/mavin.mavin.7547/',
    linkedIn: 'https://www.linkedin.com/in/mavinsandeep/',
    twitter: 'https://twitter.com/mavin_sandeep/',
    stackOverflow: 'https://stackoverflow.com/users/19005661/mavin-sandeep',
    instagram:'https://instagram.com/mavin_sandeep/'
}